module.exports = __webpack_public_path__ + "media/images/pear_tree_20-09be4f4649c2138acc8acf0adaf3a518.jpg";